import { render, staticRenderFns } from "./tai-xiu-board-layout.vue?vue&type=template&id=843d5e92&scoped=true"
import script from "./tai-xiu-board-layout.vue?vue&type=script&lang=js"
export * from "./tai-xiu-board-layout.vue?vue&type=script&lang=js"
import style0 from "./tai-xiu-board-layout.vue?vue&type=style&index=0&id=843d5e92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843d5e92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('843d5e92')) {
      api.createRecord('843d5e92', component.options)
    } else {
      api.reload('843d5e92', component.options)
    }
    module.hot.accept("./tai-xiu-board-layout.vue?vue&type=template&id=843d5e92&scoped=true", function () {
      api.rerender('843d5e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/tai-xiu-board-layout.vue"
export default component.exports